import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import Icon from "../../elements/icon";

export default function PreviewRow({ label = "", value = "", icon, disclaimer, footnote, financingPlan }) {


  return (
    <div className="preview-row">
      <span className="preview-row-label">{label}</span>
      <div className="value-container">
        {icon && <Icon {...icon} />}
        {value && <span className={`preview-row-value${financingPlan === 'LOAN' ? '-light' : ''}`}>{value}</span>}
        {footnote && <span className="preview-row-footnote">{footnote}</span>}
        {disclaimer && <span className="preview-row-disclaimer">{disclaimer}</span>}
      </div>
    </div>
  );
}

PreviewRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  disclaimer: PropTypes.string,
  financingPlan: PropTypes.string,
  icon: PropTypes.object
};
